import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Home from '../containers/home/Home';
import Error404 from '../containers/Error404';
import localDB from "../data/localDB";
import DeliveryHome from "../containers/home/DeliveryHome";

class HomeRoute extends Component {

    render() {
        let home_component = ''
        if(localDB.get('user').rol === 'R'){
            home_component = DeliveryHome
        }else{
            home_component = Home
        }
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/' component={home_component}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default HomeRoute;



// WEBPACK FOOTER //
// ./src/routes/HomeRoute.js